(() => {
if (customElements.get('slideshow-banner')) return;

//web component for media height adjustment in slideshow banner
// Usage: <slideshow-banner></slideshow-banner>
class SlideshowBanner extends HTMLElement {
  constructor() {
    super();
    this.mediaContainer = this.querySelectorAll(".slideshow__media")[0];
  }
  connectedCallback() {
    this.adjustBannerMediaHeight();
    this._debouncedResize = this._debounce(this.adjustBannerMediaHeight.bind(this), 150);
    window.addEventListener("resize", this._debouncedResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._debouncedResize);
  }

  _debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  adjustBannerMediaHeight() {
    const textConainer = this.querySelectorAll(".slideshow__text")[0];
    const windowWidth = window.innerWidth;
    const textBoxHeight = textConainer.clientHeight + 36;
    if (
      windowWidth <= 749 &&
      this.mediaContainer &&
      this.mediaContainer.classList.contains("slideshow__banner--mobile-bottom")
    ) {
      this.mediaContainer.style.height = `calc(100% - ${textBoxHeight}px)`;
    } else {
      this.mediaContainer.style.height = "100%";
    }
  }
}
customElements.define("slideshow-banner", SlideshowBanner);
})();
